import { z } from 'zod';

export const Address = z.object({
  addressLine1: z.string().min(1, 'Required'),
  addressLine2: z.string().optional(),
  townCity: z.string().min(1, 'Required'),
  stateCounty: z.string().min(1, 'Required'),
  postalCode: z.string().min(1, 'Required'),
  country: z.string().min(1, 'Required')
});

export type Address = z.infer<typeof Address>;

export const Contact = z.object({
  personalEmail: z.string().optional(),
  workEmail: z.string().min(1, 'Required'),
  telephoneNumber: z.string().min(1, 'Required')
});

export type Contact = z.infer<typeof Contact>;

export const RegisteredInfo = z.object({
  name: z.string(),
  address: z.string(),
  number: z.string(),
  employeeCount: z.number(),
  vatNumber: z.string()
});

export type RegisteredInfo = z.infer<typeof RegisteredInfo>;

export const User = z.object({
  id: z.string(),
  givenName: z.string(),
  surname: z.string(),
  role: z.number(),
  email: z.string()
});

export type User = z.infer<typeof User>;
